// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1y_G8","fileBtn":"File_fileBtn__pPMA3","closeBtn":"File_closeBtn__1Am-D","fileSelected":"File_fileSelected__3BlOs","disabled":"File_disabled__8x62L"};